module.exports = __webpack_public_path__ + "img/Unidad2-1.bd0ad156.png";